// Real-world FLIR thermal photo of ecoHeatwave ceiling panels in operation.
// The source asset is a 2×2 thermal grid; we crop to the bottom-right tile.
const IMG =
  "https://customer-assets.emergentagent.com/job_thermal-design-3/artifacts/naq66bmd_image.png";

export default function InvisibleByDesign() {
  return (
    <section id="invisible" data-testid="invisible-section" className="py-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <h2
              className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-[-0.02em] leading-[1.05] text-ecoh-ink"
              data-testid="invisible-headline"
            >
              Comfort you feel.
              <br />
              <span>Technology you don't see.</span>
            </h2>
            <p className="mt-10 text-ecoh-muted text-lg md:text-xl leading-relaxed max-w-2xl font-light">
              ecoHeatwave is installed behind the plasterboard ceiling,
              delivering even radiant warmth throughout the space without
              radiators, noise, or visual disruption.
            </p>
            <p className="mt-6 text-ecoh-muted text-base md:text-lg leading-relaxed max-w-2xl font-light">
              Once the ceiling is finished, the only evidence of ecoHeatwave
              is the warmth itself — captured here by a thermal camera in an
              installation.
            </p>
          </div>
          <div className="lg:col-span-5">
            <div className="max-w-[85%] mx-auto lg:ml-auto lg:mr-0">
              <div
                className="relative rounded-2xl overflow-hidden bg-ecoh-ink aspect-square"
                data-testid="invisible-image"
                role="img"
                aria-label="Thermal camera views of a real ecoHeatwave installation — rooms warming evenly with panels radiating from the ceiling"
              >
                <img
                  src={IMG}
                  alt=""
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </div>
              <p className="mt-3 text-xs tracking-[0.2em] uppercase text-ecoh-muted">
                Thermal imaging · ecoHeatwave installation
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
